import {RootState} from "../../../store";

export const getShowNavbarDesktop = (state: RootState) => state.navbarReducer.isShowNavbarDesktop;
